// extracted by mini-css-extract-plugin
export var borderA = "style-module--borderA--09253";
export var borderB = "style-module--borderB--6890c";
export var contents = "style-module--contents--b8be6";
export var footer = "style-module--footer--c946e";
export var header = "style-module--header--48af6";
export var headerLogo = "style-module--headerLogo--6282f";
export var headings = "style-module--headings--06252";
export var instagram = "style-module--instagram--08dc5";
export var language = "style-module--language--233db";
export var link = "style-module--link--b0d5e";
export var menu = "style-module--menu--7cd64";
export var menuLogo = "style-module--menuLogo--a24ae";
export var menuModal = "style-module--menuModal--c3b58";
export var menuSwitch = "style-module--menuSwitch--8512f";